import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import Utils from "../../../utils/Utils";
import Device from "../../../devices/device";


class AddAdminDeviceTask extends AbstractRequestTask {

    constructor(props) {
        super(props);
        this.serialId = Device.getDevice().getConfig().serial_id;
    }

    getHeaders() {
        return {}
    }

    getUrl() {
        const http = "http://";
        const url = Launcher.get("akamai_mfwk");
        let _url = `${http}${url}/services/admin/devices?`
        _url += Utils.buildQueryParams(this.getGETParams());

        return _url;
    }

    getGETParams() {
        const params = super.getParams();
        return Object.assign({}, params, { serial_id: this.serialId });
    }

    getParams() {
        return {};
    }

    isValid(data) {
        if(
            data.errors 
            || (data.response && Array.isArray(data.response.not_elegibles))
            ) {
            return false;
        }
        return true;
    }

    getShowErrorModal(){
        return DISABLE_MODAL_RETRIES;
    }
    

    getMethod() {
        return 'POST';
    }

    getEncType() {
        return 'text/json'
    }
}

    export default AddAdminDeviceTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/device/AddAdminDeviceTask.js